<template>
    <div v-loading.fullscreen="loading">
        <div v-if="!loading">
            <el-breadcrumb style="float: right" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }"> {{$t('route.home')}}</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ name: 'clubList' }">$t('entities.club.plural')</el-breadcrumb-item>
                <el-breadcrumb-item
                    v-if="editing && model"
                    :to="{ name: 'clubShow', params: { id: model.id } }"
                >{{ model.name }}</el-breadcrumb-item>
                <el-breadcrumb-item v-if="editing">{{$t('table.edit')}}</el-breadcrumb-item>
                <el-breadcrumb-item v-if="!editing">{{$t('table.add')}}</el-breadcrumb-item>
            </el-breadcrumb>

      <h2 class="page-title"> {{ editing ? $t('table.edit') + ' ' + $t('entities.club.singular') : $t('table.add') + ' ' + $t('entities.club.singular') }}</h2>

            <el-form
                ref="form"
                :model="model"
                :label-position="labelPosition"
                :label-width="labelWidth"
                :rules="rules"
                @submit.native.prevent="save"
            >
                <div class="block">
                    <el-form-item label="Name" prop="name">
                        <el-col :lg="11" :md="16" :sm="24">
                            <el-input v-model="model.name" ref="focus"/>
                        </el-col>
                    </el-form-item>
              
                    <el-form-item label="Email Manager" prop="emailManager">
                        <el-col :lg="11" :md="16" :sm="24">
                            <el-input 
                                :disabled="model.statusManager == 'verified'"
                                v-model="model.emailManager"
                                 ref="focus"/>
                        </el-col>
                    </el-form-item>
                    <!-- Escudo -->
                    <el-form-item label="Escudo">
                        <el-col :lg="11" :md="16" :sm="24">
                            <div class="club-uploader" @click="toggleShow">
                                <img v-if="model.logo.url" class="avatar" :src="model.logo.url">
                                <i v-else class="el-icon-plus team-uploader-icon"></i>
                              </div>
                            <my-upload field="img"
                                @crop-success="cropSuccess"
                                v-model="show"
                                :width="300"
                                :height="300"
                                langType="es-MX"
                                img-format="png"></my-upload>
                        </el-col>
                       
                    </el-form-item>
                    <!-- Escudo -->
                </div>

                <div class="button-group mt-3">
                    <el-button
                        @click="save()"
                        :disabled="loading"
                        type="primary"
                        icon="el-icon-fa-floppy-o"
                    >Save</el-button>
                    <el-button @click="back()" :disabled="loading" icon="el-icon-fa-times">Cancel</el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import validators from "@/shared/form/validators";
import myUpload from 'vue-image-crop-upload';
// import _ from "underscore"
 /* eslint-disable */ 
export default {
    name: "app-club-form",
    components: {   
        'my-upload': myUpload
    },
    props: {
        id: String,
        previous: String
    },

    data() {
        return {
            show: false,
            
            rules: {
                name: validators.string({
                    label: "Name",
                    required: true
                }),
                emailManager: validators.email({
                    label: "Email Manager",
                    required: true
                })
            }
        };
    },

    created() {
        this.$store.dispatch("entities/club/loadOptions");
        if (this.id) {
            this.$store
                .dispatch("entities/club/edit", this.id)
                .catch(() => this.$router.push({ name: "clubList" }));
        } else {
            this.$store.dispatch("entities/club/new");
        }
    },

    beforeRouteLeave(to, from, next) {
        this.$store.dispatch("entities/club/clear");
        next();
    },

    computed: {
        ...mapGetters({
            model: "entities/club/model",
            loading: "entities/club/loading",
            labelPosition: "shared/labelPosition",
            labelWidth: "shared/labelWidth",
            options: "entities/club/options"
        }),

        editing: state => !!state.id
    },

    methods: {
        save() {
            this.$refs.form.validate().then(valid => {
                if (!valid) {
                    return;
                }

                // this.attachFilesToModel();

                this.$store.dispatch("entities/club/save", this.model).then((model) => {
                    console.log("Modle saved");
                    
                    console.log(model);
                    
                    this.back();
                });
            });
        },

        back() {
            if (this.previous === "show") {
                this.$router.push({
                    name: "clubShow",
                    params: { id: this.id }
                });
                return;
            }

            this.$router.push({ name: "clubList" });
        },

        attachFilesToModel() {
            this.model.pictures = this.$refs.pictures.data || [];
        },

        toggleShow() {
            this.show = !this.show;
        },
        /**
         * crop success
         *
         * [param] imgDataUrl
         * [param] field
         */
        cropSuccess(imgDataUrl, field){
            console.log('-------- crop success --------');
            var data =  imgDataUrl.slice(22,imgDataUrl.length )
            var logo = { 
                name: "logo.png",
                size: data.length,
                dataB64: data,
                url: imgDataUrl
            }
            this.model.logo = logo
        }
    }
};
</script>


<style>
  .team-uploader{
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 178px;
    height: 178px;
  }
  .team-uploader:hover {
    border-color: #409EFF;
  }
  .team-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/entities/club/club-form.vue?096bcd0e